import { Outlet } from "react-router";
import { cn } from "@/lib/utils";
import { SidebarInset, SidebarProvider } from "../ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { SearchEverywhere } from "../searchEverywhere/index";
import { SearchEverywhereProvider } from "../searchEverywhere/context";

export default function Root() {
  return (
    <SearchEverywhereProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset
          className={cn(
            // Set content container, so we can use container queries
            "@container/content",

            // If layout is fixed, set the height
            // to 100svh to prevent overflow
            "has-data-[layout=fixed]:h-svh",

            // If layout is fixed and sidebar is inset,
            // set the height to 100svh - spacing (total margins) to prevent overflow
            "peer-data-[variant=inset]:has-data-[layout=fixed]:h-[calc(100svh-(var(--spacing)*4))]",
          )}
        >
          <Outlet />
        </SidebarInset>
        <SearchEverywhere />
      </SidebarProvider>
    </SearchEverywhereProvider>
  );
}
